import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { useNavigate } from "react-router-dom";

function Slider() {
  const navigate = useNavigate();

  return (
    <div className="relative w-full overflow-hidden bg-black">

      {/* ================= SLIDER ================= */}
      <Swiper
        modules={[Autoplay]}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        loop
        speed={900}
        slidesPerView={1}
        spaceBetween={0}

        /* ✅ HEIGHT INCREASED */
        className="w-full h-[500px] sm:h-[600px] md:h-[500px]"
      >

        {/* SLIDE 1 */}
        <SwiperSlide>
          <div className="w-full h-full overflow-hidden bg-black">
            <img
              src="/assets/swiper/home.webp"
              alt="slider"
              className="block w-full h-full object-cover"
            />
          </div>
        </SwiperSlide>

        {/* SLIDE 2 */}
        <SwiperSlide>
          <div className="w-full h-full overflow-hidden bg-black">
            <img
              src="/assets/swiper/home2.webp"
              alt="slider"
              className="block w-full h-full object-cover"
            />
          </div>
        </SwiperSlide>

        {/* SLIDE 3 */}
        <SwiperSlide>
          <div className="w-full h-full overflow-hidden bg-black">
            <img
              src="/assets/swiper/home3.webp"
              alt="slider"
              className="block w-full h-full object-cover"
            />
          </div>
        </SwiperSlide>

        {/* SLIDE 4 */}
        <SwiperSlide>
          <div className="w-full h-full overflow-hidden bg-black">
            <img
              src="/assets/swiper/roadmash.png"
              alt="slider"
              className="block w-full h-full object-cover"
            />
          </div>
        </SwiperSlide>

        {/* SLIDE 5 */}
        <SwiperSlide>
          <div className="w-full h-full overflow-hidden bg-black">
            <img
              src="/assets/swiper/skyrace.png"
              alt="slider"
              className="block w-full h-full object-cover"
            />
          </div>
        </SwiperSlide>

        {/* SLIDE 6 */}
        <SwiperSlide>
          <div className="w-full h-full overflow-hidden bg-black">
            <img
              src="/assets/swiper/battlearena.png"
              alt="slider"
              className="block w-full h-full object-cover"
            />
          </div>
        </SwiperSlide>
      </Swiper>

      {/* ================= LEFT TEXT ================= */}
      <div className="absolute inset-0 z-10 flex items-center">
        <div className="max-w-7xl mx-auto w-full px-6 sm:px-10">
          <div className="max-w-xl text-left text-white">

            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3">
              Level Up Your Game
            </h1>

            <p className="text-base sm:text-lg mb-6 text-gray-200">
              Play Without Limits
            </p>

            {/* ✅ BUTTON UPDATED (LOGO COLOR GRADIENT) */}
            <button
              onClick={() => navigate("/signin")}
              className="px-6 py-3 rounded-lg font-semibold text-white 
              bg-gradient-to-r from-[#ff003c] to-[#6a00ff]
              hover:scale-105 transition-all duration-300 shadow-lg"
            >
              Let&apos;s Play
            </button>

          </div>
        </div>
      </div>

      {/* ================= FIX ================= */}
      <style>{`
        .swiper {
          overflow: hidden;
        }
        .swiper-slide {
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
          transform: translateZ(0);
        }
        img {
          display: block;
        }
      `}</style>
    </div>
  );
}

export default Slider;